import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @file Region 区域
 */
import { getDefaultElementSize } from '@tencent/glue-util-boundary';
import { Emitter } from '@tencent/glue-util-emitter';
import { AxisType } from '../enum';
import { Axis } from './Axis';
import { Point } from './Point';
export var Region = /*#__PURE__*/function (_Emitter) {
  _inherits(Region, _Emitter);

  var _super = _createSuper(Region);

  function Region() {
    var _this;

    _classCallCheck(this, Region);

    _this = _super.call(this);
    _this.axisMap = {};
    _this.pointMap = {};
    _this.size = getDefaultElementSize();
    _this.dragging = false;

    _this.createAxis(AxisType.HORIZONTAL);

    _this.createAxis(AxisType.VERTICAL);

    return _this;
  }

  _createClass(Region, [{
    key: "repaint",
    value: function repaint() {
      this.emit('repaint');
    } // 获取数据点

  }, {
    key: "getPoint",
    value: function getPoint(part) {
      if (!this.pointMap[part]) {
        throw new Error("Point ".concat(part, " is not found"));
      }

      return this.pointMap[part];
    } // 获取坐标轴

  }, {
    key: "getAxis",
    value: function getAxis(type) {
      if (!this.axisMap[type]) {
        throw new Error("Axis ".concat(type, " is not found"));
      }

      return this.axisMap[type];
    } // 获取坐标轴长度

  }, {
    key: "getAxisLength",
    value: function getAxisLength(type) {
      return type === AxisType.HORIZONTAL ? this.size.width : this.size.height;
    }
  }, {
    key: "updateRegionSize",
    value: function updateRegionSize(size) {
      var old = this.size;
      this.size = size;
      var xChanged = false;
      var yChanged = false;

      if (this.axisMap[AxisType.HORIZONTAL] && old.width !== size.width) {
        this.getAxis(AxisType.HORIZONTAL).repaint();
        xChanged = true;
      }

      if (this.axisMap[AxisType.VERTICAL] && old.height !== size.height) {
        this.getAxis(AxisType.VERTICAL).repaint();
        yChanged = true;
      }

      if (xChanged || yChanged) {
        this.repaintPoint();
      }

      this.repaint();
    }
  }, {
    key: "getDragging",
    value: function getDragging() {
      return this.dragging;
    }
  }, {
    key: "setDragging",
    value: function setDragging(dragging) {
      if (this.dragging !== dragging) {
        this.dragging = dragging;

        if (!dragging) {
          this.repaintPoint();
        }
      }
    }
  }, {
    key: "createAxis",
    value: function createAxis(type) {
      if (this.axisMap[type]) {
        throw new Error("Axis ".concat(type, " has already exist"));
      }

      return this.axisMap[type] = new Axis(this, type);
    }
  }, {
    key: "createPoint",
    value: function createPoint(part, type) {
      if (this.pointMap[part]) {
        throw new Error("Point ".concat(part, " has already exist"));
      }

      return this.pointMap[part] = new Point(this, type, part);
    } // 刷新坐标轴对应的点

  }, {
    key: "repaintPoint",
    value: function repaintPoint() {
      var _this2 = this;

      Object.keys(this.pointMap).forEach(function (key) {
        return _this2.getPoint(key).updatePointValue();
      });
    }
  }]);

  return Region;
}(Emitter);